import React from "react";
import { Typography } from "@mui/material";
import Table from "../../../react_utils/table/Table";
import Checkbox from "../../../react_utils/fields/Checkbox";
import { round } from "../../../shared/utils/utils";
import DropDown from "../../../react_utils/fields/DropDown";

export const getInverterTable = (form) => {
  return (
    <>
      <Typography fontSize="h6.fontSize" color="primary" align="center">
        Wechselrichter
      </Typography>
      <Table
        columns={[
          { name: "Gerät", key: "name", style: { width: "20%" } },
          {
            name: "Modbus-Config",
            key: "modbus_address",
            style: { width: "20%" },
          },
          {
            name: "Batterie",
            key: "battery_capacity",
            style: { width: "20%" },
          },
        ]}
        rows={form.impulsinverter_set.map((inverter) => ({
          name: inverter.identifier,
          modbus_address: inverter.address.substring(7),
          battery_capacity: `${round(inverter.battery_capacity, 2)} kWh`,
          state: inverter.state_representation,
        }))}
      />
    </>
  );
};

export const getWallboxTable = (form) => {
  return (
    <>
      <Typography fontSize="h6.fontSize" color="primary" align="center">
        Wallboxen
      </Typography>
      <Table
        columns={[
          { name: "Gerät", key: "name", style: { width: "20%" } },
          {
            name: "Modbus-Config",
            key: "modbus_address",
            style: { width: "20%" },
          },
        ]}
        rows={form.impulswallbox_set.map((wallbox) => ({
          name: wallbox.identifier,
          modbus_address: wallbox.address.substring(7),
          state: wallbox.state_representation,
        }))}
      />
    </>
  );
};

export const getRelayTable = (form, checkRelayHeatpump) => {
  return (
    <>
      <Typography fontSize="h6.fontSize" color="primary" align="center">
        Relais
      </Typography>
      <Table
        columns={[
          { name: "Gerät", key: "name", style: { width: "20%" } },
          {
            name: "Modbus-Config",
            key: "modbus_address",
            style: { width: "20%" },
          },
          {
            name: "Wärmepumpe",
            key: "actions",
            style: { width: "20%" },
          },
        ]}
        rows={form.impulsrelay_set.map((relay) => {
          const heatpump = form.impulsheatpump_set.find(
            (h) => h.relay === relay.id,
          );
          return {
            name: relay.identifier,
            modbus_address: relay.address.substring(7),
            state: relay.state_representation,
            actions: (
              <Checkbox
                checked={!!heatpump}
                disabled={form.configured}
                onChange={(checked) => checkRelayHeatpump(relay, checked)}
              />
            ),
          };
        })}
      />
    </>
  );
};

export const getEMeterTable = (form, deviceList, assignEMeter) => {
  return (
    <>
      <Typography fontSize="h6.fontSize" color="primary" align="center">
        Zähler
      </Typography>
      <Table
        columns={[
          { name: "Gerät", key: "name", style: { width: "20%" } },
          {
            name: "Modbus-Config",
            key: "modbus_address",
            style: { width: "20%" },
          },
          {
            name: "Zuweisung",
            key: "actions",
            style: { width: "20%" },
          },
        ]}
        rows={form.impulsemeter_set.map((emeter) => ({
          name: emeter.identifier,
          modbus_address: emeter.address.substring(7),
          state: emeter.state_representation,
          actions: (
            <DropDown
              onChange={(value) => assignEMeter(emeter, value)}
              options={deviceList}
              disabled={form.configured}
              value={
                deviceList.find((d) => d.emeter === emeter.id)?.value || null
              }
              label="Gerät wählen"
            />
          ),
        }))}
      />
    </>
  );
};

export const getHeatpumpTable = (form) => {
  return (
    <>
      <Typography fontSize="h6.fontSize" color="primary" align="center">
        Wärmepumpen
      </Typography>
      <Table
        columns={[
          { name: "Gerät", key: "name", style: { width: "20%" } },
          {
            name: "Modbus-Config",
            key: "modbus_address",
            style: { width: "20%" },
          },
        ]}
        rows={form.impulsheatpump_set.map((heatpump) => ({
          name: heatpump.identifier,
          modbus_address: form.impulsrelay_set
            .find((r) => r.id === heatpump.relay)
            .address.substring(7),
          state: heatpump.state_representation,
        }))}
      />
    </>
  );
};
